import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { WorksheetMock } from '../WorksheetMock';
import { CtaButton } from '../CtaButton';
type Sheet = 'sesion' | 'plan' | 'ficha';
const sheets: {
  id: Sheet;
  label: string;
}[] = [{
  id: 'sesion',
  label: 'Sesión lista'
}, {
  id: 'plan',
  label: 'Plan de intervención'
}, {
  id: 'ficha',
  label: 'Ficha inicial'
}];
const slots = [{
  x: '-50%',
  y: 36,
  rotate: -1,
  scale: 1,
  zIndex: 3
}, {
  x: '-88%',
  y: 0,
  rotate: -7,
  scale: 0.9,
  zIndex: 1
}, {
  x: '-12%',
  y: 8,
  rotate: 6,
  scale: 0.9,
  zIndex: 2
}];
const pillars = ['Sesiones resueltas', 'Listas para usar', 'Fáciles de consultar'];
export function SessionsSection() {
  const [front, setFront] = useState<Sheet>('sesion');
  const others = sheets.filter(s => s.id !== front).map(s => s.id);
  const slotOf = (id: Sheet) => id === front ? 0 : others.indexOf(id) + 1;
  return <section className="overflow-hidden bg-petrol-800 py-12 text-cream sm:py-24" data-id="element-347" data-mp="1aouyh8b4mtny">
      <div className="mx-auto grid max-w-6xl items-center gap-8 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-348" data-mp="2ks568mfvmnzh">
        <div data-id="element-349" data-mp="2fumw4sq4i2pw">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-gold-300" data-id="element-350" data-mp="2ft1zmxk909pe"> +60 Sesiones listas PARA USAR</p>
          <h2 className="mt-3 font-serif text-[1.9rem] leading-tight text-balance sm:text-5xl" data-id="element-351" data-mp="2trifbe039ajo">
            ¿Y si la próxima sesión <span className="italic text-terra-300" data-id="element-352" data-mp="222gef27bnnoc">ya estuviera preparada?</span>
          </h2>
          <p className="mt-4 max-w-lg text-[15px] leading-relaxed text-petrol-100 sm:text-lg" data-id="element-353" data-mp="1x3c60ds81tz2">
            Accedé a <strong className="text-cream" data-id="element-354" data-mp="2auqrqsdik99t">sesiones resueltas y listas para usar</strong> como base de trabajo, con
            objetivos, estructura, preguntas y recursos prácticos.
          </p>
          <ul className="mt-5 flex flex-wrap items-center gap-x-2 gap-y-1 font-serif text-lg sm:mt-8 sm:block sm:space-y-1 sm:text-4xl" data-id="element-355" data-mp="1iefychu2uiyz">
            {pillars.map((p, i) => <li key={p} className="flex items-center sm:block" data-id="element-356" data-mp="1ecck5lg0x0a0" data-mpi={i}>
                {i > 0 && <span className="mr-2 text-terra-300 sm:mr-3" aria-hidden="true" data-id="element-357" data-mp="3dgktskzo00uc">
                    +
                  </span>}
                {p}
              </li>)}
          </ul>
          <div className="mt-8 hidden lg:block" data-id="element-358" data-mp="3n6vywav34g2t">
            <CtaButton data-id="element-359" data-mp="3n878wsf4ik2d" />
          </div>
        </div>

        <div data-id="element-360" data-mp="3s6s0k3gb7vf7">
          <div role="tablist" aria-label="Ver material de ejemplo" className="flex justify-center gap-1 rounded-full bg-petrol-900/60 p-1" data-id="element-361" data-mp="3s5h0adm2p5su">
            {sheets.map(s => <button key={s.id} type="button" role="tab" aria-selected={front === s.id} onClick={() => setFront(s.id)} className={`flex-1 whitespace-nowrap rounded-full px-2 py-2 text-[11px] font-semibold uppercase tracking-wide transition-colors duration-150 ease-out sm:text-xs ${front === s.id ? 'bg-cream text-petrol-900' : 'text-petrol-100 hover:text-cream'}`} data-id="element-362" data-mp="2zhus0s1whczn">
                {s.label}
              </button>)}
          </div>

          <div className="relative mx-auto mt-5 h-[400px] w-full max-w-[460px] sm:h-[480px]" data-id="element-363" data-mp="ooqo1gzwdwip">
            {sheets.map(s => {
            const slot = slots[slotOf(s.id)];
            return <motion.button key={s.id} type="button" onClick={() => setFront(s.id)} aria-label={`Ver ${s.label}`} initial={false} animate={{
              x: slot.x,
              y: slot.y,
              rotate: slot.rotate,
              scale: slot.scale
            }} transition={{
              duration: 0.28,
              ease: [0.23, 1, 0.32, 1]
            }} style={{
              zIndex: slot.zIndex
            }} className="absolute left-1/2 top-0 w-[60%] text-left focus-visible:outline-none" data-id="element-364" data-mp="2487rdaimvjh2">
                  <WorksheetMock variant={s.id} data-id="element-365" data-mp="1gidi12xiwd1k" />
                </motion.button>;
          })}
          </div>

          <div className="relative z-10 mt-6 lg:hidden" data-id="element-366" data-mp="1bl3szoe1q3e9">
            <CtaButton className="w-full" data-id="element-367" data-mp="3ax670j3wi5kj" />
          </div>
        </div>
      </div>
    </section>;
}